import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { GetCatalogCategoriesResponse as Category } from '@medindex-webapi';
import { HelixRoutes } from '@shared/enums/routes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-selection-modal',
  templateUrl: './category-selection-modal.component.html',
  styleUrls: ['./category-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategorySelectionModalComponent {
  @Input() selectedCategory: Category | undefined;
  @Input() categories: Category[] = [];

  private router = inject(Router);
  private modal = inject(ModalService);

  changeCategory(category: string | null): void {
    this.router.navigate([HelixRoutes.Catalog, category]);
    this.modal.destroyAll();
  }

  trackBy(index: number, category: Category): number {
    return category.id;
  }
}
